import React from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

const RoleDebugPanel: React.FC = () => {
  const { user, userRole, forceRefreshAuth, isLoading } = useSupabaseAuth();

  if (!user) return null;

  return (
    <Card className="border-yellow-500/50 bg-yellow-500/5">
      <CardHeader>
        <CardTitle className="text-sm flex items-center justify-between">
          <span>🔍 Role Debug Panel</span>
          <Button 
            size="sm" 
            variant="outline" 
            onClick={forceRefreshAuth}
            disabled={isLoading}
          >
            <RefreshCw className={`h-3 w-3 mr-1 ${isLoading ? 'animate-spin' : ''}`} />
            Refresh
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-xs">
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">User ID:</span>
          <code className="text-xs bg-muted px-2 py-1 rounded">{user.id.slice(0, 8)}...</code>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Email:</span>
          <span className="font-mono text-xs">{user.email}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Current Role:</span>
          <Badge variant={userRole === 'admin' ? 'destructive' : userRole === 'staff' ? 'secondary' : 'outline'}>
            {userRole}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Role Source:</span>
          <span className="text-xs">Database (live)</span>
        </div>
        <div className="pt-2 border-t border-yellow-500/20 text-xs text-muted-foreground">
          💡 If role shown is incorrect, click Refresh to clear cache and fetch from database
        </div>
      </CardContent>
    </Card>
  );
};

export default RoleDebugPanel;
